import { render } from "./EditMonTemplateView.vue?vue&type=template&id=48b1f1e6&scoped=true"
import script from "./EditMonTemplateView.vue?vue&type=script&lang=js"
export * from "./EditMonTemplateView.vue?vue&type=script&lang=js"

import "./EditMonTemplateView.vue?vue&type=style&index=0&id=48b1f1e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b1f1e6"]])

export default __exports__